module.exports = __webpack_public_path__ + "static/media/DEENCONNECT_MasjidBaitusSalam_17.dc1be895.jpeg";